import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from './Icon'
import zIndex from '../../utils/zIndexScale'
import { withI18n } from '../../i18n/util'
import isElectron from '../../utils/isElectron'

const termsOfServiceLink = isElectron() ? 'https://trubi.io/en/terms' : '/en/terms'
const PrivacyLink = isElectron() ? 'https://trubi.io/en/terms' : '/en/privacy'
const copyrightTextId = isElectron() ? 'account.footer.copyright.trubi' : 'account.footer.copyright'

const Wrapper = styled.div`
  height: 50px;
  line-height: 50px;
  background: ${({ theme }) => theme.headerBg};
  width: 100%;
  color: ${({ theme }) => theme.fontColor};
  display: flex;
  font-size: 13px;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  z-index: ${zIndex.footer};
  @media (max-width: 768px) {
    justify-content: flex-start;
    display: none;
  }
`

const LeftPane = styled.ul`
  display: flex;
  margin-left: 90px;
  li {
    margin-right: 30px;
  }
  a {
    color: inherit;
    &:hover {
      color: #f0b90b;
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`

const RightPane = styled.div`
  display: flex;
  margin-right: 90px;
  @media (max-width: 768px) {
    margin-right: 0;
    width: 100%;
    justify-content: space-around;
  }
`

const CopyRight = styled.div`
  margin-right: 5px;
`

const SocialList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  li {
    margin-right: 5px;
    a {
      /* stylelint-disable-line */
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: ${({ theme }) => theme.exchangeMainBg};
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      i {
        color: ${({ theme }) => theme.fontColor};
      }
      &:hover i {
        color: ${({ theme }) => theme.highlight};
      }
    }
  }
`

const Footer = ({ formatI18nText }) => (
  <Wrapper>
    <LeftPane>
      <li>
        <a href={termsOfServiceLink} target="blank" rel="noopener">
          {formatI18nText('footer.terms')}
        </a>
      </li>
      <li>
        <a href={PrivacyLink} target="blank" rel="noopener">
          {formatI18nText('footer.privacy')}
        </a>
      </li>
      <li>
        <a href="https://community.binance.org/" target="blank" rel="noopener">
          {formatI18nText('header.forums')}
        </a>
      </li>
      <li>
        <a href="https://docs.binance.org/" target="blank" rel="noopener">
          {formatI18nText('header.faq')}
        </a>
      </li>
    </LeftPane>
    <RightPane>
      <CopyRight>
        {formatI18nText(copyrightTextId).replace('2019', new Date().getFullYear())}
      </CopyRight>
      <SocialList>
        <li>
          <a href="https://t.me/BinanceDEXchange " target="blank" rel="noopener">
            <Icon type="telegram" size={14} />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/BinanceChain" target="blank" rel="noopener">
            <Icon type="twitter" size={14} />
          </a>
        </li>
      </SocialList>
    </RightPane>
  </Wrapper>
)

Footer.propTypes = {
  formatI18nText: PropTypes.func,
}

Footer.defaultProps = {
  formatI18nText: () => {},
}

export default withI18n(Footer)
